import { FC, useState } from 'react'

import LockClosedIcon from '@heroicons/react/outline/LockClosedIcon'
import RssIcon from '@heroicons/react/outline/RssIcon'
import { useClipboard } from 'use-clipboard-copy'

import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Input } from '@tribeplatform/react-ui-kit/Input'
import { Link } from '@tribeplatform/react-ui-kit/Link'

export type ShareRssType = {
  postId?: string
  memberId?: string
  spaceId?: string
  isPrivate?: boolean
}

export const ShareRss: FC<ShareRssType> = ({
  postId,
  memberId,
  spaceId,
  isPrivate,
}) => {
  const { data: network } = useNetwork()
  const [copied, setCopied] = useState(false)
  const clipboard = useClipboard()
  let url = ''
  if (postId) url = `https://${network.domain}/rss/post/${postId}/replies`
  else if (spaceId) url = `https://${network.domain}/rss/${spaceId}/posts`
  else if (memberId)
    url = `https://${network.domain}/rss/member/${memberId}/posts`
  else return null

  return (
    <div className="flex flex-col space-y-5">
      {!isPrivate && (
        <>
          <Input
            onClick={e => e.currentTarget.select()}
            value={url}
            readOnly
            trailingAddon={
              <Link
                onClick={() => {
                  clipboard.copy(url)
                  setCopied(true)
                  setTimeout(() => setCopied(false), 2000)
                }}
                variant="neutral"
              >
                {copied ? 'Copied' : 'Copy'}
              </Link>
            }
          />
        </>
      )}
      <p className="flex space-x-3 items-center">
        <RssIcon className="w-16 h-16 text-[#ee802f]" />
        <span>
          Add the feed of this page to your blog or favorite RSS reader such as
          Feedly or Mailbrew to stay up to date!
        </span>
      </p>
      {isPrivate && (
        <div className="bg-surface-100 rounded-md p-3 flex text-sm">
          <LockClosedIcon className="flex-shrink-0 w-5 h-5 mr-2 inline-block" />
          <span>
            <strong>This page is private</strong>. RSS feed only works with
            public pages.
          </span>
        </div>
      )}
    </div>
  )
}
